<div class="dm-license-dialog-component">
	<div>
		<div>
			<div class="content scrollable">
				<h3>
					<img class="pwa-logo" [src]="'assets/img/dm-logo.svg'" />
					<span *ngIf="!isDMLicensed">Try DataMaster Now!</span>
					<span *ngIf="isDMLicensed">DataMaster License Enabled</span>
				</h3>
				<div class="instructions">

					<div class="mb-4">
						<span *ngIf="!isDMLicensed">
							Get access to more powerful features:
						</span>
						<span *ngIf="isDMLicensed">
							You already have access to more powerful features:
						</span>
						<ul>
							<li>
								<strong>Property Search:</strong>
								Div into a more detailed view of the property
							</li>
							<li>
								<strong>Market Analysis:</strong>
								Gain insights into market trends and make data-driven decisions.
							</li>
						</ul>

						<span *ngIf="isDMLicensed">
							Begin by exploring your orders, or jump straight into using the <a [href]="'/property/search'"> Property Search Feature </a>
						</span>
						<span *ngIf="!isDMLicensed">
							Please request access to upgrade your license and unlock all our tools.
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="flex-container action-buttons">
			<button
				id="closeDialogAcceptance"
				pButton
				(click)="closeDialog()"
				class="p-button-text" type="button" label="Close">
			</button>
		</div>
	</div>
</div>
